import DateTimeFormatOptions = Intl.DateTimeFormatOptions;

export function getLocalDate(
	inputDate: string | Date,
	locale: string,
	monthFormat: DateTimeFormatOptions['month'] = 'long',
	weekdayFormat: DateTimeFormatOptions['weekday'] = 'long',
): [weekday: string, day: string, month: string] {
	let date = new Date(inputDate);
	date = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

	const weekday = date.toLocaleDateString(locale, {weekday: weekdayFormat});
	const day = date.toLocaleDateString(locale, {day: '2-digit'});

	// Use an extra "day" to get correct a month name case
	const month = date.toLocaleDateString(locale, {month: monthFormat, day: 'numeric'}).replace(/[ \d.]/g, '');

	return [weekday, day, month];
}
